import { RichText } from '../atoms/RichText';
import { useDOMPurify } from '../../../lib/useDOMPurify';
import { SimpleReactComponentProps } from '../../../types/components';

export interface TextBlockProps extends SimpleReactComponentProps {
	content: string;
}

const textBlockClasses = 'flex flex-1 scroll-mt-[84px]';

export const TextBlock = ({
	content,
	classOverrides,
	anchorId,
}: TextBlockProps) => {
	const sanitizedContent = useDOMPurify(content);

	return (
		<div className={classOverrides || textBlockClasses} id={anchorId?.value}>
			<RichText richText={sanitizedContent} />
		</div>
	);
};
